import type { SaveProgressRpc } from "../rpc-client";

type SaveProgressInput = Parameters<SaveProgressRpc["saveProgress"]>[0];

interface PersistCurrentStepBeforeExitOptions {
  currentStepId: string;
  formData: Record<string, Record<string, unknown>>;
  productId: SaveProgressInput["productId"];
  rpcClient: SaveProgressRpc;
}

export async function persistCurrentStepBeforeExit({
  currentStepId,
  formData,
  productId,
  rpcClient,
}: PersistCurrentStepBeforeExitOptions): Promise<void> {
  await rpcClient.saveProgress({
    currentStepId,
    productId,
    sourceStepId: currentStepId,
    stepData: formData[currentStepId],
  });
}
